module.exports = __webpack_public_path__ + "static/s-0-a2150e56f595afdccae1edee2a88fe2e.svg";